(() => {
  const root = window.Shopify?.routes?.root || '/';

  const menuButton = document.querySelector('[data-menu-toggle]');
  const navigation = document.querySelector('[data-navigation]');
  if (menuButton && navigation) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      navigation.classList.toggle('is-open', !isOpen);
    });
  }

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const select = section.querySelector('[data-variant-select]');
    const price = section.querySelector('[data-product-price]');
    if (!select || !price) return;
    select.addEventListener('change', () => {
      price.textContent = select.selectedOptions[0]?.dataset.price || price.textContent;
    });
  });

  document.querySelectorAll('[data-configurator]').forEach((form) => {
    const modelSelect = form.querySelector('[data-phone-model]');
    const includeCase = form.querySelector('[data-include-case]');
    const caseData = form.querySelector('[data-case-variants]');
    const status = form.querySelector('[data-configurator-status]');
    const submit = form.querySelector('button[type="submit"]');

    const parseVariants = (element) => {
      if (!element) return [];
      try { return JSON.parse(element.textContent); } catch (_) { return []; }
    };
    const findVariant = (variants, model) => variants.find((variant) => variant.options?.includes(model));
    const setStatus = (message, isError = false) => {
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('is-error', isError);
    };

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const model = modelSelect?.value;
      const checkedPanels = Array.from(form.querySelectorAll('input[name="panel-product"]:checked'));

      if (!model) {
        setStatus('Choose your iPhone model first.', true);
        modelSelect?.focus();
        return;
      }
      if (checkedPanels.length === 0) {
        setStatus('Choose at least one Melbourne back panel.', true);
        return;
      }

      const caseVariant = findVariant(parseVariants(caseData), model);
      const items = [];

      if (includeCase?.checked) {
        if (!caseVariant) {
          setStatus(`The blank case is not configured for ${model}.`, true);
          return;
        }
        items.push({ id: caseVariant.id, quantity: 1 });
      }
      for (const checkedPanel of checkedPanels) {
        const panelLabel = checkedPanel.closest('.panel-choice');
        const panelVariant = findVariant(parseVariants(panelLabel?.querySelector('[data-panel-variants]')), model);
        if (!panelVariant) {
          const panelName = panelLabel?.querySelector('.panel-choice__title')?.textContent?.trim() || 'A selected panel';
          setStatus(`${panelName} is not configured for ${model}.`, true);
          return;
        }
        items.push({ id: panelVariant.id, quantity: 1 });
      }

      submit.disabled = true;
      setStatus(`Adding ${items.length} selection${items.length === 1 ? '' : 's'}…`);
      try {
        const response = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Unable to add these selections.');
        }
        window.location.assign(`${root}cart`);
      } catch (error) {
        setStatus(error.message || 'Unable to add these selections.', true);
        submit.disabled = false;
      }
    });
  });
})();

